import { esc } from "../ui/format.js";

/**
 * One sidebar tab, several pages behind big buttons (the Investments & Offers pattern, views/investhub.js).
 * Rachit (2026-10-24): merge tabs that say the same kind of thing.
 *
 *   🌐 World Economy   Economy (views/core/macro.js) · Currencies (core/fx.js) · News (core/news.js)
 *   🏆 Rankings        Real companies (views/ranking.js) · Players (views/league.js)
 *
 * The old tab keys still open the right page (shell.showTab("fx") opens World Economy on Currencies), and
 * each page keeps the panels registered for its old tab (emRegister("fx", ...)). The page you picked is remembered.
 */

const HUBS = {
  macro: {
    label: "World economy", pages: [
      { key: "macro", icon: "📊", title: "Economy", sub: "Growth, inflation and interest rates where you operate", render: () => window.renderMacroCore },
      { key: "fx", icon: "💱", title: "Currencies", sub: "What exchange rates do to your revenue", render: () => window.renderFXCore },
      { key: "news", icon: "🗞️", title: "News", sub: "What happened in the world and to you", render: () => window.renderNewsCore },
    ],
  },
  ranking: {
    label: "Rankings", pages: [
      { key: "ranking", icon: "🌍", title: "Real companies", sub: "Where you stand among the world's companies", render: () => window.renderRanking },
      { key: "league", icon: "🏁", title: "Players", sub: "The Player League and the weekly challenge", render: () => window.renderLeague },
    ],
  },
};
const HUB_OF = {};
for (const [hub, h] of Object.entries(HUBS)) for (const p of h.pages) HUB_OF[p.key] = hub;

function hubPage(hub, asked) {
  if (asked && HUB_OF[asked] === hub && asked !== hub) return asked;
  try {
    const saved = localStorage.getItem(`ges.hub.${hub}`);
    if (HUBS[hub].pages.some((p) => p.key === saved)) return saved;
  } catch (e) { /* not remembered */ }
  return HUBS[hub].pages[0].key;
}

async function renderHub(hub, main, snap, asked) {
  const h = HUBS[hub];
  let page = hubPage(hub, asked);
  main.innerHTML = `<div class="ih">
      <div class="ih-switch hub-switch" role="tablist" aria-label="${esc(h.label)}">${h.pages.map((p) => `
        <button type="button" role="tab" class="ih-btn" data-hub="${p.key}"><span class="ih-ico">${p.icon}</span>
          <span class="ih-txt"><b>${esc(p.title)}</b><em>${esc(p.sub)}</em></span></button>`).join("")}</div>
      <div class="ih-body"></div></div>`;
  const body = main.querySelector(".ih-body");
  const show = async (key) => {
    page = key;
    try { localStorage.setItem(`ges.hub.${hub}`, key); } catch (e) { /* not remembered */ }
    main.querySelectorAll("[data-hub]").forEach((b) => { b.classList.toggle("on", b.dataset.hub === key); b.setAttribute("aria-selected", String(b.dataset.hub === key)); });
    const host = document.createElement("div");
    body.replaceChildren(host);
    const fn = h.pages.find((p) => p.key === key).render();
    if (typeof fn === "function") await fn(host, snap);
    // the panels that belonged to the old tab (letters, moves) come along with its page
    if (window.gesTabExtras && key !== hub) await window.gesTabExtras(key, host, snap).catch(() => {});
  };
  main.querySelectorAll("[data-hub]").forEach((b) => b.addEventListener("click", () => { if (b.dataset.hub !== page) show(b.dataset.hub); }));
  await show(page);
}

window.gesHubOf = (tab) => HUB_OF[tab] || null;
window.renderHub = renderHub;

export { HUB_OF, renderHub };
